const doc = [({"en":({"js":({"admin":({"photo_products":({"table":({"unknown_resource_type":"Unknown resource type: %{resource_type}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;